import IconArrow from '@/assets/icons/icon-arrow-down.svg'
import { DropdownIndicatorProps, GroupBase, components, OptionProps } from 'react-select'
import { OptionType } from '.'
import convertToReadable from '@/helpers/convertToReadable'

export const selectStyles = {
    control: (provided: any, state: { isFocused: any }) => ({
        ...provided,
        width: 'auto',
        maxWidth: 'max-content',
        border: 'none',
        boxShadow: 'none',
        borderWidth: state.isFocused ? 'none' : 'none',
        borderColor: state.isFocused ? 'none' : 'none',
        outline: state.isFocused ? 'none' : 'none',
        borderRadius: '5px',
        padding: '0',
        cursor: 'pointer',
        overflow: 'hidden',
        backgroundColor: 'transparent',
    }),
    valueContainer: (provided: any) => ({
        ...provided,
        padding: '0',
        backgroundColor: 'transparent',
    }),
    singleValue: (base: any) => ({
        ...base,
        color: 'inherit',
        maxWidth: 'max-content',
    }),
    dropdownIndicator: (base: any) => ({
        ...base,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 5px 0 5px',
        color: '#1f2937',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    indicatorsContainer: (provided: any) => ({
        ...provided,
        width: '24px',
        svg: {
            path: {
                stroke: '#1f2937',
            },
        },
    }),
    option: (base: any, { isSelected, isDisabled }: any) => ({
         ...base,
         width: '156px',
         color: isDisabled ? '#cccccc' : (isSelected ? '#1f2937' : '#82868C'),
         fontSize: '18px',
         fontWeight: 700,
         cursor: isDisabled ? 'not-allowed' : 'pointer',
         backgroundColor: isSelected ? '#f0f0f0' : (isDisabled ? '#f9f9f9' : base.backgroundColor),
          ':active': {
              backgroundColor: isDisabled ? '#f9f9f9' : base[':active']?.backgroundColor,
          },
     }),
    menu: (provided: any) => {
        return {
            ...provided,
            width: 'max-content',
            padding: '15px 15px 5px 15px',
            borderRadius: '8px',
            boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.20)',
            backgroundColor: '#ffffff',
        }
    },
}

const DropdownIndicator = (
    props: DropdownIndicatorProps<OptionType, false, GroupBase<OptionType>>
) => {
    return (
        <components.DropdownIndicator {...props}>
            {} <IconArrow />
        </components.DropdownIndicator>
    )
}

export const selectComponent = {
    Option: ({ innerProps, data, isSelected, isDisabled }: any) => (
        <div
            style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '7px',
                marginBottom: '10px',
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                opacity: isDisabled ? 0.5 : 1,
            }}
            {...innerProps}
        >
            <div
                style={{
                    color: isDisabled ? '#a0a0a0' : (isSelected ? '#1f2937' : '#202020'),
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: '500',
                    lineHeight: '24px',
                }}
            >
                {data.label}
            </div>
            {/* <div
                style={{
                    color: isDisabled ? '#a0a0a0' : (isSelected ? '#1f2937' : '#202020'),
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: '500',
                    lineHeight: '24px',
                }}
            >
                {data.cityShippingMethod === '0' 
                    ? 
                        'Бесплатно' 
                    : 
                        `от ${convertToReadable(data.cityShippingMethod)} суммов`
                }
            </div> */}
        </div>
    ),
    DropdownIndicator,
}

export const formatOptionLabel = (data: OptionType) => {
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div
                style={{
                    color: '#1f2937',
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    marginLeft: '10px',
                }}
            >
                {data.label}
            </div>
            {/* <div
                style={{
                    color: '#1f2937',
                    textAlign: 'center',
                    fontSize: '16px',
                    fontWeight: '400',
                    lineHeight: '24px',
                    marginLeft: '10px',
                    marginRight: '10px',
                }}
            >
                {data.cityShippingMethod === '0' 
                    ? 
                        'Бесплатно' 
                    : 
                        `от ${convertToReadable(data.cityShippingMethod)} суммов`
                }
            </div> */}
        </div>
    )
}
